import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IPostLoginBody,
  IPostLoginResponseData,
  IPostRefreshToken,
  IPostRefreshTokenData
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private readonly baseURL = '/Login';
  constructor(private httpClient: HttpClient) {}

  postLogin(body: IPostLoginBody) {
    return this.httpClient.post<IApiResponse<IPostLoginResponseData>>(
      this.baseURL,
      body
    );
  }

  postRefreshToken(body: IPostRefreshToken) {
    return this.httpClient.post<IApiResponse<IPostRefreshTokenData>>(
      `${this.baseURL}/refreshToken`,
      body
    );
  }
}
